import React from 'react';
import image from '../../../Assets/resource/SeamlessSolorintergration.png'
import image1 from '../../../Assets/resource/SeamlessSolorintergration2.png'
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import { Button } from '../../../Atoms';

const solutions = [
    {
        title: 'Seamless solar integration',
        description:
            'Charge smarter with solar power—cut grid usage and drive down your carbon footprint',
        buttonText: 'Talk to Us About Solar + EV Integration',
        imageUrl: image,
    },
    {
        title: 'Dynamic load management',
        description:
            'Smart load balancing shifts power to your EV as needed, optimizing efficiency during peak household consumption',
        buttonText: '',
        imageUrl: image1,
    },
];

const ChargingSolutions = () => {
    const navigate = useNavigate();
    return (
        <section className=" blade-margin-top-sm">
            <div className="containers-min mx-auto text-center">
                <div className="2xl:pb-20 xl:pb-16 pb-12">
                    <h3 className="text-center font-gilroy">
                        Charging Solutions That Fit Every Scenario
                    </h3>
                    <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                        Access advanced energy management with smooth solar integration and smart load balancing
                    </p>
                    {/* <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                    In addition, out chargers are the easiest in the market to service, with 24/7 connectivity, remote diagnostics, and accessible designs that expedite maintenance and field service.
                    </p> */}
                </div>
            </div>

            <div className="containers-min mx-auto grid gap-6 sm:grid-cols-1 md:grid-cols-2">
                {/* {solutions.map((item, index) => (
                    <div
                        key={index}
                        className={`rounded-xl overflow-hidden shadow-md bg-bgGreen transition-transform transform`}
                    >
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            className="w-full h-48 object-cover sm:h-64"
                        />
                        <div className="p-6 space-y-7">
                            <h3 className="text-xl lg:text-2xl xxl:text-3xl font-bold font-gilroy px-5">{item.title}</h3>
                            <p className="leading-normal font-poppins text-start px-5  text-base md:text-xl lg:text-xl">{item.description}</p>
                            {item.buttonText && (
                                <div>
                                    <Button                                    
                                        title={item.buttonText}
                                        onClick={() => navigate('/get-in-touch')}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ))} */}
                {solutions.map((item, index) => (
                    <div
                        key={index}
                        className="relative rounded-xl overflow-hidden shadow-md bg-bgGreen transition-transform transform"
                    >
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            className="w-full h-[450px] object-cover"
                        />

                        {/* Overlay + Content (only bottom part) */}
                        <div className="absolute bottom-0 w-full">
                            {/* Overlay behind the content */}
                            <div className="bg-black bg-opacity-60 w-full px-6 py-6 space-y-4">
                                <h3 className="text-xl lg:text-2xl xxl:text-3xl font-bold font-gilroy text-white px-2">
                                    {item.title}
                                </h3>
                                <p className="font-poppins text-start px-2 text-base md:text-xl lg:text-xl text-white">
                                    {item.description}
                                </p>
                                {item.buttonText && (
                                    <div className="px-2">
                                        <Button
                                            title={item.buttonText}
                                            onClick={() => navigate('/get-in-touch')}
                                            whitebtn
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

            </div>
        </section>
    );
};

export default ChargingSolutions;
